import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTelegram, faXTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons'

const Socials = () => <>
    <a aria-label="telegram" href="https://t.me/MetFiChat" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTelegram} size="2xl" /></a>
    <a aria-label="discord" href="https://discord.gg/R7YqC5xVSW" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDiscord} size="2xl" /></a>
    <a aria-label="x" href="https://twitter.com/MetFi_DAO" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} size="2xl" /></a>
</>

export default Socials